import DefaultCheckbox from "./default-checkbox";
import VerticalCheckbox from "./vertical-checkbox";
import HorizontalCheckboxSignup from "./horizontal-checkbox-signup";

export default { DefaultCheckbox, VerticalCheckbox, HorizontalCheckboxSignup };
